import * as React from 'react';
import { Link } from '@mui/material/node';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material/node';
import NodeCanvasLogo from '../../assets/NodeCanvasLogo.svg';

export const AppBarLogo = (props) => {
    const theme = useTheme();
    return (
        <Link
            className="pointer flexNullCenter"
            sx={{ color: "theme.palette.menuIcon.main" }}
            href="/"
            underline="none"
        >
            {!props.isMobile &&
                <img
                    src={NodeCanvasLogo}
                    alt="NodeCanvas"
                    loading="lazy"
                    style={{
                        height: "32px",
                        marginRight: "10px",
                    }}
                />
            }
            {!props.isMobile &&
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: theme.palette.logoTextColor.main,
                        whiteSpace: "nowrap",
                        '&:hover': {
                            color: theme.palette.logoTextColor.main,
                        }
                    }}
                >
                    NodeCanvas
                    <Typography
                    variant="h5"
                    sx={{
                        marginRight: "10px",
                        fontSize: "10px",
                        color: theme.palette.logoTextColor.main,
                        whiteSpace: "nowrap",
                        '&:hover': {
                            color: theme.palette.logoTextColor.main,
                        }
                    }}
                >
                    (Beta)
                </Typography>
                </Typography>
            }
        </Link>

    );
}